const FALLBACK_LABEL = 'Unknown Opponent'
const SIDE = { PROPOSER: 'proposer', OPPONENT: 'opponent' }

const toDisplayName = (player = {}) =>
  [player.first_name || '', player.last_name || ''].join(' ').trim()

export const formatPlayerListDisplay = (players = []) => {
  const names = players.map(toDisplayName).filter(Boolean)
  return names.length > 0 ? names.join(' / ') : ''
}

export const getProposalSideDisplayName = (
  proposal = {},
  side = SIDE.OPPONENT,
) => {
  const playersKey =
    side === SIDE.PROPOSER ? 'proposer_players' : 'opponent_players'
  const explicitNameKey =
    side === SIDE.PROPOSER ? 'proposer_name' : 'opponent_name'

  const teamDisplayName = formatPlayerListDisplay(proposal[playersKey] || [])
  if (teamDisplayName) {
    return teamDisplayName
  }

  const explicitName = proposal[explicitNameKey]
  if (explicitName && explicitName.trim()) {
    return explicitName.trim()
  }

  return FALLBACK_LABEL
}

export const buildProposalOpponentDescriptor = (proposal = {}) => {
  const displayName = proposal.is_sent_by_user
    ? getProposalSideDisplayName(proposal, SIDE.OPPONENT)
    : getProposalSideDisplayName(proposal, SIDE.PROPOSER)

  if (displayName === FALLBACK_LABEL) return null

  const primary =
    (proposal.is_sent_by_user
      ? proposal.opponent_players?.[0]
      : proposal.proposer_players?.[0]) || {}

  return {
    display_name: displayName,
    first_name: primary.first_name || displayName,
    last_name: primary.last_name || '',
    player_id: proposal.is_sent_by_user
      ? proposal.opponent_player_id
      : proposal.proposer_player_id,
  }
}

/**
 * Returns true when the given playerId participates in the proposal on
 * either side. Handles both singles (scalar player IDs) and doubles
 * (proposer_players / opponent_players arrays).
 *
 * Null/undefined playerId never matches, even if a side's scalar id is also
 * null (as is the case for doubles proposals).
 */
export const proposalInvolvesPlayer = (proposal = {}, playerId) => {
  if (playerId == null) return false

  const otherPlayerId = proposal.is_sent_by_user
    ? proposal.opponent_player_id
    : proposal.proposer_player_id
  if (otherPlayerId != null && otherPlayerId === playerId) return true

  const otherPlayers = proposal.is_sent_by_user
    ? proposal.opponent_players
    : proposal.proposer_players
  if (
    Array.isArray(otherPlayers) &&
    otherPlayers.some((p) => p?.id === playerId)
  ) {
    return true
  }

  const sameSidePlayers = proposal.is_sent_by_user
    ? proposal.proposer_players
    : proposal.opponent_players
  return (
    Array.isArray(sameSidePlayers) &&
    sameSidePlayers.some((p) => p?.id === playerId)
  )
}
